export const fr = {
  'common.language': 'Langue',
  'common.environment': 'Environnement',
  'is.reachable': 'est accessible',
  'is.not.reachable': 'n\'est pas accessible',
  'not.found.message': 'Cette page n\'existe pas.',
  'common.back': 'Retour',
  'an.error.occurred': 'Une erreur est survenue',
  'common.back-office': 'Back-office',
  'common.routing.game-mechanics': 'Mécaniques de jeu',
  'common.routing.dialog': 'Dialogue',
  'common.routing.image': 'Clique image',
  'common.routing.multiple-choice': 'QCM',
  'common.routing.reorder': 'Reorder',
  'common.routing.single-choice': 'QCU',
  'common.routing.users': 'Utilisateurs',
  'common.routing.groups': 'Groupes',
  'common.routing.files': 'Fichiers',
  'common.routing.statistics': 'Statistiques',
  'common.routing.sessions': 'Sessions',
  'common.routing.settings': 'Paramètres',
  'common.routing.modules': 'Modules',
  'common.routing.roadmap': 'Nouveautés',
  'common.routing.certificates': 'Certificats',
  'common.routing.reminders': 'Rappels email',
  'common.routing.organizations': 'Organisations',
  'common.routing.billing': 'Facturation',
  'common.routing.sso': 'Authentification SSO',
  'common.french': 'Français',
  'common.english': 'Anglais',
  'theme.dark': 'Mode sombre',
  'theme.light': 'Mode clair',
  'common.logout': 'Déconnexion',
  'common.users': 'Utilisateurs',
  'common.group': 'Groupe',
  'common.groups': 'Groupes',
  'common.description': 'Description',
  'common.files': 'Fichiers',
  'common.results': 'résultats',
  'common.administration': 'Administration',
  'common.menu': 'Menu',
  'file-upload.success': 'Fichier téléchargé avec succès.',
  'file-upload.failed': 'Fichier non téléchargé.',
  'no.files': 'Aucun fichier.',
  'start-by-uploading-a-file-using-the-button-below': 'Commencez par télécharger un fichier en utilisant le bouton ci-dessous.',
  'common.email': 'Adresse email',
  'common.firstname': 'Prénom',
  'common.lastname': 'Nom',
  'common.role': 'Rôle',
  'common.lastConnection': 'Dernière connexion',
  'status.active': 'Activé',
  'status.pending': 'En attente',
  'common.search': 'Recherche',
  'common.add': 'Ajouter',
  'common.export': 'Exporter',
  'export.truncated': 'Export limité aux {{max}} premières lignes sur {{total}} : affinez les filtres pour tout obtenir.',
  'common.status': 'Status',
  'common.action': 'Actions',
  'common.update': 'Modifier',
  'common.delete': 'Supprimer',
  'common.impersonate': 'Consulter son espace',
  'common.previous': 'Précédent',
  'common.next': 'Suivant',
  'good.update.user': 'La modification de l\'utilisateur a été réalisée avec succès.',
  'bad.update.user': 'La modification de l\'utilisateur a échoué.',
  'update.user': 'Modifier un utilisateur',
  'input.required.message': 'Ce champ est requis',
  'input.email.message': 'Entrez votre adresse email !',
  'common.cancel': 'Annuler',
  'good.delete.user': 'La suppression de l\'utilisateur a été réalisée avec succès.',
  'bad.delete.user': 'La suppression de l\'utilisateur a échoué.',
  'delete.user': 'Supprimer un utilisateur',
  'delete.user.first-message': 'Supprimer cet utilisateur supprimera toutes ses statistiques et accès.',
  'delete.second-message': 'Êtes-vous sûr ?',
  'good.add.user': 'L\'ajout de l\'utilisateur a été réalisé avec succès.',
  'bad.add.user': 'L\'ajout de l\'utilisateur a échoué.',
  'add.user.emailUsed': 'Cette adresse email est déjà utilisée par un compte.',
  'create.user': 'Créer un utilisateur',
  'common.create': 'Créer',
  'common.home': 'Accueil',
  'common.mechanics': 'Mécaniques',
  'quiz.result.title': 'Résultat du quiz',
  'quiz.result.questions': 'Réponses correctes',
  'quiz.result.failure': 'Échec',
  'quiz.result.success': 'Réussite',
  'quiz.restart': 'Recommencer',
  'time.left': 'Temps restant',
  'quiz.question': 'Question',
  'quiz.answer.correct': 'Bonne réponse !',
  'quiz.answer.incorrect': 'Mauvaise réponse !',
  'common.validate': 'Valider',
  'common.finish': 'Terminer',
  'messages-history': 'Historique des messages',
  'no.history.infos': 'Aucun message',
  'reset.password.success': 'Un e-mail de réinitialisation a été envoyé',
  'bad.reset.message': 'L\'email de réinitialisation n\'a pas pu être envoyé.',
  'bad.server-login.message': 'Impossible de contacter le serveur !',
  'common.loading': 'Chargement',
  'reset.password': 'Réinitialiser votre mot de passe',
  'common.submit': 'Envoyer',
  'login.return-message': 'Retour à la page de connexion',
  'input.password': 'Entrez votre mot de passe !',
  'password.not-match.message': 'Les mots de passe ne correspondent pas',
  'new.password.success': 'Votre mot de passe a été mis à jour',
  'new.password': 'Nouveau mot de passe',
  'new.password.description': 'Entrez votre nouveau mot de passe',
  'common.password': 'Mot de passe',
  'common.confirm-password': 'Confirmer le mot de passe',
  'logout.pending': 'Déconnexion en cours',
  'login.microsoft': 'Connexion avec Microsoft',
  'impossible.read.token': 'Impossible de lire le token !',
  'connection.successful': 'Connexion réussie !',
  'connection.failed': 'La connexion a échoué !',
  'common.login': 'Connexion',
  'password.forgot': 'Mot de passe oublié ?',
  'common.register': 'Je me crée un compte',
  'access.denied.message': 'Vous n\'avez pas les droits d\'accès à cette page.',
  'input.password-confirm': 'Confirmez votre mot de passe',
  'good.register.message': 'L\'inscription a été réalisée avec succès.',
  'bad.register.message': 'L\'inscription a échoué.',
  'finish.register': 'Création de compte',
  'password.confirm': 'Confirmez votre mot de passe',
  'good-order.message': 'L\'ordre correct est :',
  'reset.password.description': 'Entrez votre adresse e-mail pour réinitialiser votre mot de passe',
  'common.login.description': 'Entrez votre email et votre mot de passe ci-dessous pour vous connecter à votre compte',
  'common.or': 'ou',
  'login.tagline': 'Apprenez.\nProgressez.\nCertifiez-vous.',
  'login.tagline.sub': 'Vos formations, votre progression et vos attestations, réunies en un seul endroit.',
  'login.magic-link.cta': 'Recevoir un lien de connexion',
  'login.magic-link.description': 'Entrez votre email : nous vous envoyons un lien de connexion, sans mot de passe.',
  'login.magic-link.submit': 'Envoyer le lien',
  'login.magic-link.sent.title': 'Vérifiez votre boîte mail',
  'login.magic-link.sent.description': 'Si un compte est associé à {{email}}, un lien de connexion vient d\'y être envoyé. Il expire dans 15 minutes et ne fonctionne qu\'une seule fois.',
  'login.magic-link.resend': 'Renvoyer le lien',
  'login.password.cta': 'Se connecter avec un mot de passe',
  'magic-link.checking': 'Connexion en cours',
  'magic-link.checking.description': 'Nous vérifions votre lien de connexion.',
  'magic-link.failed.title': 'Lien invalide ou expiré',
  'magic-link.failed.description': 'Ce lien a déjà été utilisé ou a expiré. Demandez-en un nouveau depuis la page de connexion.',
  'magic-link.request-new': 'Demander un nouveau lien',
  'finish.register.message': 'Entrez votre adresse mail, nom, prénom et mot de passe pour terminer votre inscription.',
  'good.reset.message': 'L\'email de réinitialisation a bien été envoyé.',
  'new.password-confirm': 'Confirmer le mot de passe',
  'passwords.not.match': 'Les mots de passe ne correspondent pas',
  'create.account': 'Créer un compte',
  'create.account.description': 'Entrez vos informations pour créer un compte',
  'create.account.success': 'Votre compte a été créé avec succès',
  'first.name': 'Prénom',
  'last.name': 'Nom',
  'new.password.message': 'Entrez votre adresse email et votre nouveau mot de passe',
  'common.ok': 'Valider',
  'common.game-mechanics': 'Mécaniques de jeu',
  'quiz-mechanisms.available': 'Mécaniques disponibles',
  'common.welcome': 'Bienvenue',
  'no.content': 'Aucun contenu',
  'common.confirm': 'Confirmer',
  'common.reset': 'Réinitialiser',
  'common.empty': 'Aucune donnée',
  'desc.sort': 'Cliquez pour trier par ordre décroissant',
  'asc.sort': 'Cliquez pour trier par ordre croissant',
  'cancel.sort': 'Cliquez pour annuler le tri',
  'your.informations': 'Vos informations',
  'you.are': 'Vous êtes',
  'your.email': 'Votre email',
  'token.creation.message': 'Votre session a été créée le :',
  'token.expiration.message': 'Votre session expirera le :',
  'common.hello': 'Bonjour',
  'user.management': 'Gestion des utilisateurs',
  'add.user': 'Ajouter un utilisateur',
  'bad.connection': 'Connexion impossible',
  'bad.connection.message': 'Le mot de passe et l’email saisis ne correspondent pas. Veuillez vérifier vos informations et vous connecter à nouveau.',
  'common.close': 'Fermer',
  'common.quiz-mechanics': 'Mécaniques de quiz',
  'import.user': 'Importer un utilisateur',
  'good.import.user': 'L\'import de l\'utilisateur a été réalisé avec succès.',
  'bad.import.user': 'L\'import de l\'utilisateur a échoué.',
  'bad.import.user.none': 'Aucun compte n\'a été créé : toutes les lignes ont été refusées.',
  'warn.import.user.partial': 'Import partiel : {{count}} ligne(s) refusée(s).',
  'download.template': 'Télécharger le modèle',
  'click.to.upload': 'Cliquez pour importer',
  'common.import': 'Importer',
  'import.csv.help': 'Fichier CSV avec les colonnes {{headers}} (séparateur point-virgule). Les apprenants reçoivent un email d\'invitation.',
  'import.csv.groupHelp': 'Colonne « groupe » facultative : le groupe est créé s\'il n\'existe pas encore.',
  'import.csv.parsed': '{{count}} ligne(s) détectée(s) dans « {{file}} ».',
  'import.preview.valid': '{{count}} ligne(s) prête(s) à être importée(s).',
  'import.preview.none': 'Aucune ligne importable dans ce fichier.',
  'import.preview.skipped': '{{count}} ligne(s) seront ignorées :',
  'import.preview.checking': 'Vérification des adresses déjà utilisées…',
  'import.check.failed': 'Impossible de vérifier les adresses déjà utilisées : elles seront contrôlées à l\'import.',
  'import.submit': 'Importer {{count}} ligne(s)',
  'import.report.created': '{{count}} compte(s) créé(s) et invité(s) par email.',
  'import.report.partial': '{{count}} compte(s) créé(s) et invité(s) par email, {{failed}} ligne(s) refusée(s).',
  'import.report.none': 'Aucun compte créé : les {{count}} ligne(s) du fichier ont été refusées.',
  'import.report.line': 'Ligne',
  'import.report.reason': 'Motif',
  'import.error.empty': 'Le fichier CSV est vide.',
  'import.error.badHeader': 'En-têtes invalides. Attendu : email ; firstName ; lastName.',
  'import.error.MISSING_FIELDS': 'Champ obligatoire manquant',
  'import.error.INVALID_EMAIL': 'Email invalide',
  'import.error.DUPLICATE_IN_FILE': 'Doublon dans le fichier',
  'import.error.EMAIL_ALREADY_USED': 'Email déjà utilisé',
  'import.error.CREATION_FAILED': 'Échec de la création',
  'common.settings': 'Paramètres',
  'unknow.error': 'Erreur inconnue !',
  'common.dashboard': 'Tableau de bord',
  'impersonate.user': 'Consulter l\'espace de {{name}}',
  'bad.impersonate.user': 'Impossible d\'ouvrir l\'espace de cet utilisateur.',
  'impersonate.user.preview': 'Vous verrez l\'application exactement telle que {{name}} la voit : ses sessions, ses modules, sa progression. Sa propre session reste ouverte de son côté, et les modules que vous ouvrez ne sont pas enregistrés pour lui.',
  'impersonate.user.not-read-only': 'Ce n\'est pas un mode lecture seule : en dehors de la progression SCORM, toute action effectuée depuis son espace sera réellement exécutée et enregistrée à son nom.',
  'impersonate.user.return-hint': 'Un bandeau en haut de l\'écran vous permettra de revenir à votre compte à tout moment.',
  'impersonate.user.confirm': 'Ouvrir son espace',
  'impersonate.started': 'Vous consultez maintenant l\'espace de {{name}}',
  'impersonate.banner.message': 'Vous consultez l\'espace de {{name}}',
  'impersonate.banner.warning': 'Sa progression n\'est pas enregistrée, mais vos autres actions le sont.',
  'impersonate.banner.exit': 'Revenir à mon compte',
  'impersonate.exit.failed': 'Impossible de restaurer votre session admin. Veuillez vous reconnecter.',
  'account.validate': 'Validation de compte',
  'account.validate.confirmation': 'Veuillez confirmer votre compte en cliquant sur le bouton ci-dessous',
  'valid.account.success': 'Votre compte a été validé avec succès !',
  'valid.account.failed': 'La validation de votre compte a échoué. Veuillez réessayer plus tard.',
  'resend.email.success': 'Email de validation envoyé avec succès',
  'resend.email.failed': 'Échec de l\'envoi de l\'email de validation',
  'resend.email': 'Renvoyer l\'email de validation',
  'scorm.player.title': 'Module SCORM',
  'scorm.player.loading': 'Chargement du module...',
  'scorm.player.error': 'Erreur lors du chargement du module SCORM',
  'scorm.progress.saved': 'Progression sauvegardée',
  'scorm.progress.save.error': 'Erreur lors de la sauvegarde de la progression',
  'common.statistics': 'Statistiques',
  'common.completionStatus': 'Statut de complétion',
  'common.successStatus': 'Statut de réussite',
  'common.score': 'Score',
  'common.completedAt': 'Date de complétion',
  'common.totalTime': 'Temps total',
  'status.completed': 'Complété',
  'status.archived': 'Archivée',
  'sessions.name': 'Session',
  'user.sessions.title': 'Sessions de l\'utilisateur',
  'user.sessions.subtitle': 'Sessions et progression de {{name}}',
  'user.sessions.empty': 'Cet utilisateur n\'est inscrit à aucune session.',
  'user.sessions.progress': 'Progression',
  'user.sessions.view': 'Voir les sessions',
  'user.progress.label': 'Avancement',
  'user.progress.all': 'Tous les avancements',
  'user.progress.notStarted': 'Jamais commencé',
  'user.progress.inProgress': 'En cours',
  'user.progress.completed': 'Terminé',
  'status.incomplete': 'Incomplet',
  'status.not_attempted': 'Non commencé',
  'status.unknown': 'Inconnu',
  'status.passed': 'Réussi',
  'status.failed': 'Échoué',
  'login.sso': 'Connexion SSO',
  'login.sso.with': 'Continuer avec {{provider}}',
  'sso.error': 'Erreur de connexion SSO',

  // Navigation & communs
  'common.modules': 'Modules',
  'common.module': 'Module',
  'common.sessions': 'Sessions',
  'common.session': 'Session',
  'common.allSessions': 'Toutes les sessions',
  'common.name': 'Nom',
  'common.organizations': 'Organisations',
  'billing.title': 'Facturation',
  'billing.help': 'Un apprenant est compté une seule fois par année contractuelle, dès sa première connexion. Les comptes admin ne comptent jamais. Ce compteur observe : il ne bloque aucune session, jamais.',
  'billing.month': 'Mois observé',
  'billing.monthlyActive': 'Actifs du mois',
  'billing.yearlyActive': 'Apprenants formés',
  'billing.registered': 'Apprenants enregistrés',
  'billing.freeTier': 'Plan gratuit',
  'billing.freeTier.within': 'Inclus ({{learners}}/{{limit}})',
  'billing.freeTier.over': 'Au-delà du gratuit',
  'billing.devis.over': 'Au-delà de {{threshold}} apprenants : parlons-nous',
  'billing.total': 'Total',
  'billing.empty': 'Aucune organisation.',
  'billing.neverBlocked': 'Au-delà du plan gratuit, la facturation suit le compteur : aucune session n\'est jamais bloquée.',
  'billing.amountDue': 'Montant du mois',
  'billing.amountDue.free': 'Inclus dans le plan gratuit ({{limit}} apprenants formés par an).',
  'billing.amountDue.overFree': 'Au-delà du plan gratuit, rien n\'est facturé tant qu\'aucune formule n\'est choisie : à ce rythme, l\'année coûterait {{amount}}.',
  'billing.amountDue.upfront': 'Année réglée d\'avance ({{amount}}) : le mois ne doit rien.',
  'billing.amountDue.monthly': 'Le prix du palier, réglé au mois. Résiliable à tout moment.',
  'billing.plan.title': 'Votre palier',
  'billing.plan.field': 'Palier',
  'billing.tier.FREE': 'Gratuit',
  'billing.tier.S': 'S',
  'billing.tier.M': 'M',
  'billing.tier.L': 'L',
  'billing.tier.XL': 'XL',
  'billing.tier.CUSTOM': 'Sur devis',
  'billing.tier.FREE.help': 'Jusqu\'à 10 apprenants sur 12 mois glissants. Essai permanent.',
  'billing.tier.S.help': 'Jusqu\'à 100 apprenants — 39 €/mois.',
  'billing.tier.M.help': 'Jusqu\'à 300 apprenants — 99 €/mois.',
  'billing.tier.L.help': 'Jusqu\'à 750 apprenants — 189 €/mois.',
  'billing.tier.XL.help': 'Jusqu\'à 1 500 apprenants — 299 €/mois.',
  'billing.tier.CUSTOM.help': 'Au-delà de 1 500 apprenants : sur devis.',
  'billing.tier.CUSTOM.notice': 'Au-delà de 1 500 apprenants, le tarif se fait sur devis — contactez-nous.',
  'billing.tier.monthlyPrice': 'Prix mensuel',
  'billing.tier.upfrontYear': 'Année au comptant (2 mois offerts)',
  'billing.term.field': 'Règlement',
  'billing.term.UPFRONT': 'Au comptant',
  'billing.term.MONTHLY': 'Au mois',
  'billing.term.UPFRONT.help': 'L\'année réglée d\'avance : deux mois offerts (10 mois payés pour 12). Non remboursable.',
  'billing.term.MONTHLY.help': 'Résiliable à tout moment ; la facturation s\'arrête à la fin du mois en cours. Sans engagement.',
  'billing.learnerCount': 'Apprenants décomptés',
  'billing.billedTier': 'Palier {{tier}}',
  'billing.placesRemaining': 'Palier {{tier}} — {{places}} places avant {{next}}',
  'billing.placesShort': '{{places}} avant {{next}}',
  'billing.leavingSoon': 'Sortants à 3 mois',
  'billing.leavingSoon.help': 'Apprenants qui quitteront le compteur d\'ici 3 mois s\'ils ne sont ni réinscrits ni revenus.',
  'billing.plan.save': 'Enregistrer la formule',
  'billing.plan.saved': 'Formule enregistrée.',
  'billing.plan.error': 'Formule non enregistrée.',
  'billing.plan.loading': 'Chargement de votre formule…',
  'billing.plan.belowFloor': 'Vos {{learners}} apprenants décomptés placent votre organisation au palier {{tier}}, qui est donc déjà celui facturé. Souscrire en dessous ne changerait rien : ces paliers restent grisés tant que le compteur ne redescend pas. Côté apprenants, rien n\'est bloqué — ni session, ni attestation.',
  'billing.plan.noPaymentYet': 'Le changement prend effet immédiatement. Le règlement en ligne arrive prochainement : aucun prélèvement n\'est déclenché ici.',
  'billing.yearly.base': 'Socle de l\'année',
  'billing.yearly.commitmentAmount': 'Année engagée',
  'billing.yearly.tolerated': 'Apprenants couverts',
  'billing.yearly.overage': 'Régularisation estimée',
  'billing.yearly.overage.monthly': 'Sans objet : vos apprenants sont facturés au fil des mois.',
  'billing.yearly.estimate': 'À ce rythme, l\'année contractuelle coûtera {{amount}}.',
  'billing.profile.title': 'Coordonnées de facturation',
  'billing.profile.help': 'Reprises telles quelles sur vos factures. Un champ laissé vide n\'empêche rien.',
  'billing.profile.companyName': 'Raison sociale',
  'billing.profile.vatNumber': 'N° de TVA intracommunautaire',
  'billing.profile.addressLine1': 'Adresse',
  'billing.profile.addressLine2': 'Complément d\'adresse',
  'billing.profile.postalCode': 'Code postal',
  'billing.profile.city': 'Ville',
  'billing.profile.country': 'Pays',
  'billing.profile.billingEmail': 'Email de facturation',
  'billing.profile.saved': 'Coordonnées enregistrées.',
  'billing.profile.error': 'Coordonnées non enregistrées.',
  'billing.history.title': 'Historique',
  'billing.history.help': 'Douze derniers mois. Les montants sont recalculés avec votre formule actuelle : les factures réelles arriveront avec le règlement en ligne.',
  'billing.history.month': 'Mois',
  'billing.history.counted': 'Entrées au compteur',
  'billing.history.amount': 'Montant',
  'billing.plan': 'Formule',
  'billing.estimatedRevenue': 'Revenu estimé',
  // Stockage (#180) : mesuré partout, plafonné sur le seul plan gratuit.
  'storage.title': 'Stockage',
  'storage.size': 'Taille',
  'storage.used': 'Utilisé',
  'storage.quota': 'Plafond',
  'storage.usedOfQuota': '{{used}} / {{quota}}',
  'storage.remaining': 'Il vous reste {{remaining}}.',
  'storage.moduleCount': '{{count}} module(s)',
  'storage.noQuota': 'Votre formule n\'impose aucun plafond de stockage.',
  'storage.overQuota': 'Vous avez dépassé le stockage inclus dans le plan gratuit. Vos modules restent accessibles à vos apprenants ; seuls les nouveaux imports sont refusés le temps de faire de la place ou de choisir une formule payante.',
  'storage.overQuota.badge': 'Au-delà du plafond',
  'storage.uploadRefused': 'Import refusé faute de place : vous occupez {{used}} sur les {{quota}} du plan gratuit, et ce module en demande {{incoming}} de plus. Supprimez un module devenu inutile, ou passez à une formule payante pour lever le plafond.',
  'storage.platform.title': 'Stockage par organisation',
  'storage.platform.help': 'Ce que la plateforme héberge réellement. Le plafond ne s\'applique qu\'aux organisations au plan gratuit : ailleurs, on mesure sans rien refuser.',
  'organization.create': 'Créer une organisation',
  'organization.create.help': 'L\'administrateur reçoit un email d\'invitation pour finaliser son compte.',
  'organization.slug': 'Identifiant (URL)',
  'organization.members': 'Membres',
  'organization.suspended': 'Suspendue',
  'organization.suspend': 'Suspendre',
  'organization.activate': 'Activer',
  'organization.admin.email': 'Email de l\'administrateur',
  'organization.edit.title': 'Modifier l\'organisation',
  'organization.edit.required': 'Le nom et l\'identifiant sont requis.',
  'organization.edit.success': 'Organisation mise à jour.',
  'organization.edit.failed': 'Mise à jour échouée (identifiant déjà utilisé ou invalide ?).',
  'organization.edit.slug.help': 'Changer l\'identifiant modifie l\'URL de connexion de l\'organisation.',
  'organization.delete.title': 'Supprimer l\'organisation',
  'organization.delete.confirm': 'Confirmer la suppression de « {{name}} » ? Cette action est irréversible.',
  'organization.delete.success': 'Organisation supprimée.',
  'organization.delete.failed': 'Suppression échouée.',
  'organization.delete.notEmpty': 'Retirez d\'abord tous les membres : une organisation non vide ne peut pas être supprimée.',
  'organization.delete.default': 'L\'organisation par défaut ne peut pas être supprimée.',
  'organization.members.title': 'Membres — {{name}}',
  'organization.members.empty': 'Aucun membre.',
  'organization.member.invite.title': 'Inviter un membre',
  'organization.member.invite.required': 'Email, prénom et nom sont requis.',
  'organization.member.invite.submit': 'Inviter',
  'organization.member.invite.success': 'Invitation envoyée.',
  'organization.member.invite.failed': 'Invitation échouée.',
  'organization.member.invite.emailUsed': 'Cet email est déjà utilisé.',
  'organization.member.remove': 'Retirer',
  'organization.member.remove.success': 'Membre retiré.',
  'organization.member.remove.failed': 'Retrait échoué.',
  'good.add.organization': 'L\'organisation a été créée et son administrateur invité.',
  'bad.add.organization': 'La création de l\'organisation a échoué.',
  'common.title': 'Titre',
  'common.version': 'Version',
  'common.save': 'Enregistrer',
  'common.remove': 'Retirer',
  'common.choose': 'Choisir…',
  'common.participants': 'Participants',

  // White-label / branding
  'branding.identity': 'Identité de l\'application',
  'branding.appName': 'Nom de l\'application',
  'branding.logo': 'Logo',
  'branding.noLogo': 'Aucun logo',
  'branding.favicon': 'Favicon',
  'branding.noFavicon': 'Aucun favicon',
  'branding.colorsTypography': 'Couleurs & typographie',
  'branding.primaryColor': 'Couleur primaire',
  'branding.accentColor': 'Couleur d\'accent',
  'branding.headingFont': 'Police des titres',
  'branding.bodyFont': 'Police du corps',
  'branding.misc': 'Divers',
  'branding.footerText': 'Texte du pied de page',
  'branding.footerPlaceholder': 'Laisser vide pour un pied de page par défaut',
  'branding.defaultLocale': 'Langue par défaut',
  'branding.imageTooLarge': 'Image trop volumineuse (max 512 Ko).',
  'branding.readError': 'Impossible de lire le fichier.',
  'branding.saved': 'Configuration enregistrée.',
  'branding.saveError': 'Échec de l\'enregistrement.',

  // Modules SCORM
  'modules.import.title': 'Importer un module SCORM',
  'modules.package': 'Package (.zip)',
  'modules.chooseFile': 'Choisir un fichier…',
  'modules.list.title': 'Modules',
  'modules.empty': 'Aucun module. Importez un package SCORM.',
  'modules.titlePlaceholder': 'Nom du module',
  'modules.status.ready': 'Prêt',
  'modules.status.processing': 'Traitement…',
  'modules.status.failed': 'Échec',
  'modules.selectFile': 'Sélectionnez un fichier .zip SCORM.',
  'modules.uploadFailed': 'Import échoué',
  'modules.imported': 'Module importé.',
  'modules.deleted': 'Module supprimé.',
  'modules.deleteFailed': 'Suppression échouée.',
  'modules.preview': 'Prévisualiser',

  // Sessions (back-office)
  'sessions.create.title': 'Créer une session',
  'sessions.namePlaceholder': 'Nom de la session',
  'sessions.selectModule': '— Choisir un module —',
  'sessions.startDate': 'Début (optionnel)',
  'sessions.endDate': 'Fin (optionnel)',
  'sessions.noUsers': 'Aucun utilisateur.',
  'sessions.list.title': 'Sessions',
  'sessions.empty': 'Aucune session.',
  'sessions.nameRequired': 'Renseignez un nom et un module.',

  // Parcours multi-modules (#139) et déblocage programmé (#182)
  'sessions.path.title': 'Modules du parcours',
  'sessions.path.count_one': '{{count}} module',
  'sessions.path.count_other': '{{count}} modules',
  'sessions.path.empty': 'Aucun module. Ajoutez-en un pour composer le parcours.',
  'sessions.path.add': 'Ajouter',
  'sessions.path.required': 'Un parcours doit contenir au moins un module.',
  'sessions.path.opensOn': 'Ouvre le',
  'sessions.path.reorder': 'Déplacer {{title}} dans le parcours',
  'sessions.path.remove': 'Retirer {{title}} du parcours',
  'sessions.path.stage.on_one': '{{count}} module à la même date',
  'sessions.path.stage.on_other': '{{count}} modules à la même date',
  'sessions.path.stage.immediate_one': '{{count}} module ouvert dès le début',
  'sessions.path.stage.immediate_other': '{{count}} modules ouverts dès le début',
  'sessions.path.stage.setDate': 'Date d\'ouverture du palier',
  'sessions.path.warn.afterEnd': 'Cette date tombe après la fin du parcours : le module n\'ouvrirait jamais.',
  'sessions.path.warn.beforeStart': 'Cette date précède le début du parcours : le module ouvrira au démarrage.',
  'sessions.path.warn.inProgress_one': 'Ce parcours compte {{count}} inscrit. Modifier ses modules change son avancement : un apprenant qui l\'avait terminé y repassera « en cours » et perdra l\'accès à son attestation.',
  'sessions.path.warn.inProgress_other': 'Ce parcours compte {{count}} inscrits. Modifier ses modules change leur avancement : les apprenants qui l\'avaient terminé y repasseront « en cours » et perdront l\'accès à leur attestation.',
  'sessions.progression.label': 'Progression',
  'sessions.progression.free': 'Libre',
  'sessions.progression.sequential': 'Séquentielle',
  'sessions.progression.free.hint': 'L\'apprenant suit les modules dans l\'ordre qu\'il veut.',
  'sessions.progression.sequential.hint': 'Chaque module s\'ouvre à la complétion du précédent. Une date d\'ouverture s\'y ajoute, elle ne la remplace pas.',

  // Parcours vu par l'apprenant (#139 / #182)
  // Pas de pluriel ici : i18next l'accorde sur `count`, or le nombre qui varie
  // est `done` face à `total`. La forme « x / y » évite l'accord des deux côtés.
  'home.path.summary': '{{done}} / {{total}} modules terminés',
  'home.path.opensOn': 'À partir du {{date}}',
  'home.path.awaitingPrevious': 'Il s\'ouvrira dès que vous aurez terminé le précédent',
  'scorm.player.step': 'Étape {{current}} sur {{total}}',
  'sessions.created': 'Session créée.',
  'sessions.createFailed': 'Création échouée.',
  'sessions.deleted': 'Session supprimée.',
  'sessions.deleteFailed': 'Suppression échouée.',
  'sessions.new': 'Nouvelle session',
  'sessions.update.title': 'Modifier la session',
  'sessions.updated': 'Session mise à jour.',
  'sessions.updateFailed': 'Mise à jour échouée.',
  'sessions.openModule': 'Ouvrir le module',
  'sessions.participants.selectAll': 'Tout sélectionner',
  'sessions.participants.clear': 'Tout désélectionner',
  'sessions.participants.addGroup': 'Inscrire un groupe :',

  // Groupes d'utilisateurs (#135)
  'groups.list.title': 'Groupes',
  'groups.new': 'Nouveau groupe',
  'groups.empty': 'Aucun groupe.',
  'groups.memberCount': 'Membres',
  'groups.members': 'Membres',
  'groups.create.title': 'Créer un groupe',
  'groups.update.title': 'Modifier le groupe',
  'groups.namePlaceholder': 'Nom du groupe (ex. Mairie de Lyon)',
  'groups.nameRequired': 'Renseignez un nom.',
  'groups.nameUsed': 'Un groupe porte déjà ce nom.',
  'groups.created': 'Groupe créé.',
  'groups.createFailed': 'Création échouée.',
  'groups.updated': 'Groupe mis à jour.',
  'groups.updateFailed': 'Mise à jour échouée.',
  'groups.deleted': 'Groupe supprimé.',
  'groups.deleteFailed': 'Suppression échouée.',
  'groups.delete.title': 'Supprimer le groupe',
  'groups.delete.message': 'Supprimer « {{name}} » ? Les {{count}} membres du groupe conservent leur compte : seul le regroupement disparaît.',
  'groups.none': 'Aucun groupe',
  'groups.all': 'Tous les groupes',
  'groups.select': '— Choisir un groupe —',
  'groups.bulk.selected': '{{count}} sélectionné(s)',
  'groups.bulk.selectPage': 'Sélectionner toute la page',
  'groups.bulk.add': 'Affecter',
  'groups.bulk.remove': 'Retirer',
  'groups.bulk.added': 'Utilisateurs affectés au groupe.',
  'groups.bulk.removed': 'Utilisateurs retirés du groupe.',
  'groups.bulk.failed': 'Opération échouée.',

  // Sessions (apprenant)
  'sessions.my.title': 'Mes sessions',
  'sessions.my.empty': 'Rien à l\'horizon pour le moment.',
  'sessions.my.start': 'C\'est parti',

  // Accueil apprenant. On s'adresse à quelqu'un qui se forme sur son temps, pas
  // à un dossier : on le salue par son prénom et on lui parle de ce qui l'attend.
  'home.title': 'Mes formations',
  'home.subtitle': 'Bonjour {{name}} ! Vos formations, votre progression et vos attestations sont réunies ici.',
  'home.inProgress': 'En cours',
  'home.resume': 'Reprendre',
  'home.review': 'Revoir',
  'home.completedOn': 'Terminé le',
  'home.certificate.download': 'Attestation',
  'home.certificate.error': 'Impossible de télécharger l\'attestation.',
  'home.summary_one': '{{count}} formation terminée sur {{total}}',
  'home.summary_other': '{{count}} formations terminées sur {{total}}',
  'home.empty.hint': 'Dès qu\'un formateur vous inscrira à une formation, elle apparaîtra ici.',

  // Attestations (back-office)
  'common.certificates': 'Attestations',
  'certificates.template.title': 'Modèle d\'attestation',
  'certificates.field.title': 'Titre',
  'certificates.field.body': 'Texte',
  'certificates.field.signature': 'Signature',
  'certificates.field.signaturePlaceholder': 'Nom du signataire (optionnel)',
  'certificates.field.showScore': 'Afficher le score',
  'certificates.field.showDate': 'Afficher la date',
  'certificates.field.showTotalTime': 'Afficher le temps passé',
  'certificates.field.orientation': 'Orientation',
  'certificates.orientation.landscape': 'Paysage',
  'certificates.orientation.portrait': 'Portrait',
  'certificates.field.logo': 'Logo de l\'attestation',
  'certificates.logo.help': 'PNG ou JPEG, 512 Ko max. Sinon, le logo de la plateforme est utilisé.',
  'certificates.logo.fallback': 'Aucun logo dédié — le logo de la plateforme sera utilisé.',
  'certificates.logo.upload': 'Téléverser',
  'certificates.logo.remove': 'Retirer',
  'certificates.logo.typeError': 'Format non supporté : PNG ou JPEG uniquement.',
  'certificates.logo.sizeError': 'Fichier trop volumineux (512 Ko max).',
  'certificates.logo.readError': 'Lecture du fichier impossible.',
  'certificates.field.skeleton': 'Squelette PDF (papier à en-tête)',
  'certificates.skeleton.help': 'PDF 1 page, 3 Mo max, non protégé. Sert de fond ; le cadre décoratif n\'est alors pas dessiné.',
  'certificates.skeleton.active': 'Squelette chargé',
  'certificates.skeleton.none': 'Aucun squelette',
  'certificates.skeleton.upload': 'Téléverser un PDF',
  'certificates.skeleton.replace': 'Remplacer',
  'certificates.skeleton.remove': 'Retirer',
  'certificates.skeleton.typeError': 'Le squelette doit être un fichier PDF.',
  'certificates.skeleton.sizeError': 'PDF trop volumineux (3 Mo max).',
  'certificates.skeleton.readError': 'Lecture du PDF impossible.',
  'certificates.field.margins': 'Marges du texte (points)',
  'certificates.margins.help': 'Position du bloc de texte, surtout utile avec un squelette. 0 à 300.',
  'certificates.margins.marginTop': 'Haut',
  'certificates.margins.marginBottom': 'Bas',
  'certificates.margins.marginLeft': 'Gauche',
  'certificates.margins.marginRight': 'Droite',
  'certificates.placeholders.help': 'Variables disponibles :',
  'certificates.preview': 'Prévisualiser',
  'certificates.previewError': 'Impossible de générer la prévisualisation.',
  'certificates.saved': 'Modèle enregistré.',
  'certificates.saveError': 'Échec de l\'enregistrement.',
  'common.reminders': 'Rappels email',
  'reminders.cadence.title': 'Cadence des rappels',
  'reminders.message.title': 'Message envoyé',
  'reminders.field.enabled': 'Activer les rappels',
  'reminders.enabled.help': 'Les apprenants inscrits qui n\'ont pas terminé leur formation reçoivent une relance automatique.',
  'reminders.field.firstDelayDays': 'Délai avant le 1er rappel (jours)',
  'reminders.field.frequencyDays': 'Intervalle entre deux rappels (jours)',
  'reminders.frequencyDays.help': '3 jours minimum : en dessous, la relance passe pour du spam.',
  'reminders.field.maxReminders': 'Nombre maximum de rappels',
  'reminders.maxReminders.help': 'Entre 1 et 10 rappels par inscription. L\'option « sans limite » n\'existe plus : relancer indéfiniment fait classer vos messages en spam, y compris les convocations et les attestations.',
  'reminders.field.sendHour': 'Heure d\'envoi (0-23)',
  'reminders.field.subject': 'Objet',
  'reminders.field.body': 'Corps du message',
  'reminders.placeholders.help': 'Variables disponibles :',
  'reminders.sendTest': 'M\'envoyer un test',
  'reminders.testSent': 'Rappel de test envoyé à {{email}}.',
  'reminders.testError': 'Échec de l\'envoi du test. Vérifiez la configuration SMTP.',
  'reminders.saved': 'Rappels enregistrés.',
  'reminders.saveError': 'Échec de l\'enregistrement.',

  // SSO (#40)
  'common.sso': 'Authentification SSO',
  'sso.picker.title': 'Fournisseur à configurer',
  'sso.picker.help': 'Choisissez un fournisseur pour afficher ses champs. Vous pouvez en configurer et en activer plusieurs : ceux qui ne sont pas à l\'écran restent en place.',
  'sso.picker.configured': 'Déjà configurés :',
  'sso.picker.none': 'Aucun fournisseur configuré pour le moment.',
  'sso.picker.status.enabled': 'activé',
  'sso.picker.status.draft': 'brouillon',
  'sso.intro': 'Activez un ou plusieurs fournisseurs d\'identité pour votre organisation. Tant qu\'aucun n\'est activé, l\'écran de connexion n\'affiche aucun bouton SSO.',
  'sso.master.title': 'Connexion par SSO',
  'sso.master.help': 'Interrupteur général, au-dessus des fournisseurs. Désactivé tant que vous ne l\'allumez pas ; le couper à nouveau retire tous les boutons SSO de l\'écran de connexion sans effacer les configurations ci-dessous.',
  'sso.master.off': 'Le SSO est coupé : aucun bouton n\'apparaît sur l\'écran de connexion, même pour les fournisseurs activés ci-dessous.',
  'sso.master.turnedOn': 'Connexion par SSO activée.',
  'sso.master.turnedOff': 'Connexion par SSO coupée.',
  'sso.field.enabled': 'Activé',
  'sso.field.label': 'Libellé du bouton',
  'sso.label.help': 'Texte affiché sur l\'écran de connexion.',
  'sso.field.issuer': 'Issuer',
  'sso.field.clientId': 'Client ID',
  'sso.field.clientSecret': 'Client secret',
  'sso.clientSecret.help': 'Chiffré avant enregistrement. Il ne sera plus jamais réaffiché.',
  'sso.clientSecret.stored': 'Secret enregistré. Laissez vide pour le conserver.',
  'sso.field.entryPoint': 'URL de connexion de l\'IdP',
  'sso.field.idpIssuer': 'Entity ID de l\'IdP',
  'sso.field.idpCert': 'Certificat de signature (PEM)',
  'sso.field.allowedDomains': 'Domaines email autorisés',
  'sso.allowedDomains.help': 'Vide = tout domaine renvoyé par le fournisseur est accepté. Un compte est créé automatiquement à la première connexion.',
  'sso.allowedDomains.required': 'Ce fournisseur authentifie aussi des comptes hors de votre organisation — toute adresse Gmail dans le cas de Google. Renseignez au moins un domaine pour pouvoir l\'activer.',
  'sso.idpSetup.title': 'À déclarer côté fournisseur :',
  'sso.saved': 'Fournisseur enregistré.',
  'sso.saveError': 'Échec de l\'enregistrement.',
  'sso.deleted': 'Fournisseur supprimé.',
  'sso.deleteError': 'Échec de la suppression.',
  'sso.delete.title': 'Supprimer {{provider}}',
  'sso.delete.first-message': 'La configuration et le client secret seront perdus : le rétablir suppose d\'en réémettre un côté fournisseur. Si ce fournisseur est activé, les apprenants qui passent par lui ne pourront plus se connecter.',
  'sso.callback.checking': 'Connexion en cours',
  'sso.callback.checking.description': 'Nous validons votre identité auprès de votre fournisseur.',
  'sso.callback.failed.title': 'Connexion impossible',
  'sso.callback.failed.description': 'Le lien de connexion a expiré ou a déjà été utilisé. Relancez la connexion depuis l\'écran d\'accueil.',
  'sso.error.generic': 'La connexion SSO a échoué. Réessayez ou contactez votre administrateur.',
  'sso.error.domainNotAllowed': 'Votre domaine email n\'est pas autorisé pour cette organisation.',
  'sso.error.accountDisabled': 'Votre compte est désactivé. Contactez votre administrateur.',
  'sso.error.emailAlreadyUsed': 'Cette adresse est déjà rattachée à une autre organisation.',
  'sso.error.providerUnavailable': 'Ce fournisseur d\'identité est indisponible.',

  // Player SCORM
  'scorm.player.backToSessions': 'Mes sessions',
  'scorm.player.unavailable': 'Module indisponible pour cette session.',
  'scorm.player.contentError': 'Le contenu de ce module est introuvable. Contactez un administrateur.',

  // Écran de fin du player (le module a appelé Terminate)
  'scorm.finished.completedTitle': 'Félicitations, vous avez terminé ce module !',
  'scorm.finished.title': 'Fin du module',
  'scorm.finished.redirect': 'Vous allez être redirigé automatiquement dans quelques secondes…',

  // Impersonation dans le player
  'scorm.impersonate.noTracking': 'Mode consultation : progression non enregistrée',

  // Prévisualisation module (Admin/Formateur)
  'scorm.preview.badge': 'Prévisualisation',
  'scorm.preview.noTracking': 'Aucune progression n\'est enregistrée.',
  'scorm.preview.backToModules': 'Retour aux modules',
  'scorm.preview.unavailable': 'Ce module n\'est pas prêt à être joué.',

  // Export statistiques
  'stats.export.email': 'Email',
  'stats.export.session': 'Session',
  'stats.export.completion': 'Complétion',
  'stats.export.success': 'Réussite',
  'stats.export.score': 'Score',
  'stats.export.totalTime': 'Temps total',
  'stats.export.completedAt': 'Complété le',

  // Tableau de bord statistiques
  'stats.dashboard.progressTitle': 'Avancement',
  'stats.dashboard.scope': 'parcours suivis (apprenant × session)',
  'stats.dashboard.noEnrollments': 'Aucun apprenant inscrit sur ce périmètre.',
  'stats.dashboard.notYetUnlocked': 'Pas encore ouvert',
  'stats.dashboard.notYetUnlocked.hint': '{{modules}} modules ne sont pas encore débloqués pour leurs apprenants : ils comptent dans l\'effectif sans compter comme du retard.',
  'stats.dashboard.neverOpened': '{{learners}} inscrits n\'ont jamais ouvert leur module : ils comptent dans l\'effectif, mais ne figurent pas dans la table ci-dessous.',
  'stats.dashboard.averageScore': 'Moyenne des résultats',
  'stats.dashboard.scoredOn': 'sur {{scored}} parcours notés sur {{total}}',
  'stats.dashboard.noScore': 'Aucun score renseigné sur ce périmètre',
  'stats.dashboard.successRate': 'Taux de réussite',
  'stats.dashboard.successOn': '{{passed}} réussis sur {{evaluated}} évalués',
  'stats.dashboard.noSuccess': 'Aucun verdict de réussite sur ce périmètre',
  'stats.dashboard.averageTime': 'Temps moyen passé',
  'stats.dashboard.timedOn': 'sur {{timed}} parcours chronométrés sur {{total}}',
  'stats.dashboard.noTime': 'Aucune durée relevée sur ce périmètre',

  // Accueil back-office (#201). Des phrases, pas des libellés d'indicateur :
  // chaque ligne de cet écran se lit à voix haute. Le ton est celui d'un
  // collègue qui fait le point le matin — cordial, jamais comptable : on dit
  // « il reste des gens à accompagner », pas « 4 non-conformités ».
  'common.routing.home': 'Accueil',
  'backHome.greeting': 'Bonjour {{name}}',
  'backHome.subtitle.attention_one': 'Quelque chose vous attend aujourd\'hui.',
  'backHome.subtitle.attention_other': '{{count}} choses vous attendent aujourd\'hui.',
  'backHome.subtitle.clear': 'Tout est à jour : rien ne vous attend aujourd\'hui.',
  'backHome.section.attention': 'À regarder de près',
  'backHome.section.upcoming': 'Ça arrive bientôt',
  'backHome.section.today': 'Les bonnes nouvelles du jour',
  'backHome.overdue.title_one': '{{name}} : {{count}} apprenant n\'a pas encore terminé',
  'backHome.overdue.title_other': '{{name}} : {{count}} apprenants n\'ont pas encore terminé',
  // Sans pronom d'objet : « les relancer » sonne faux sur une ligne qui ne
  // compte qu'un apprenant, et « le » supposerait un genre.
  'backHome.overdue.detail': 'L\'échéance était le {{date}}. C\'est le moment de relancer.',
  'backHome.overdue.more_one': 'Et {{count}} autre parcours dans le même cas.',
  'backHome.overdue.more_other': 'Et {{count}} autres parcours dans le même cas.',
  'backHome.overdue.learners_one': 'En tout, {{count}} apprenant est concerné.',
  'backHome.overdue.learners_other': 'En tout, {{count}} apprenants sont concernés, certains sur plusieurs parcours.',
  'backHome.endingSoon.title': '{{name}} se termine le {{date}}',
  'backHome.endingSoon.detail_one': 'Il reste {{count}} apprenant sur {{total}} à accompagner.',
  'backHome.endingSoon.detail_other': 'Il reste {{count}} apprenants sur {{total}} à accompagner.',
  'backHome.startingSoon.title': '{{name}} démarre le {{date}}',
  'backHome.startingSoon.detail_one': '{{count}} apprenant est attendu.',
  'backHome.startingSoon.detail_other': '{{count}} apprenants sont attendus.',
  'backHome.completedToday.title_one': '{{count}} apprenant a bouclé « {{module}} »',
  'backHome.completedToday.title_other': '{{count}} apprenants ont bouclé « {{module}} »',
  'backHome.neverStarted.title_one': '{{count}} apprenant n\'a pas encore fait ses premiers pas',
  'backHome.neverStarted.title_other': '{{count}} apprenants n\'ont pas encore fait leurs premiers pas',
  // Accordé au nombre, et sans pronom : « il » supposerait un genre qu'on ne
  // connaît pas, et le masculin générique désignerait ici des personnes réelles.
  'backHome.neverStarted.detail_one': 'Inscrit à un parcours déjà démarré, sans avoir encore ouvert de module.',
  'backHome.neverStarted.detail_other': 'Inscrits à un parcours déjà démarré, sans avoir encore ouvert de module.',
  'backHome.empty': 'Rien à signaler : pas d\'échéance proche, personne à relancer. Profitez-en.',
  'backHome.empty.cta': 'Jeter un œil aux parcours',

  'notice.stats.title': 'Vos données et le suivi de votre formation',
  'notice.stats.intro': '{{appName}} enregistre votre progression afin de produire le suivi pédagogique de votre formation. Cette information vous est donnée à titre de transparence : elle n’appelle aucune démarche de votre part.',
  'notice.stats.purpose': 'Finalité : mesurer la progression, la complétion et la réussite des apprenants, et produire les attestations et justificatifs d’assiduité que votre organisme de formation doit être en mesure de fournir.',
  'notice.stats.data': 'Données concernées : votre identité (nom, prénom, adresse e-mail) associée à votre progression sur les modules.',
  'notice.stats.legalBasis': 'Base légale : l’exécution de votre contrat de formation (article 6.1.b du RGPD) et les obligations légales de traçabilité qui pèsent sur votre organisme de formation (article 6.1.c).',
  'notice.stats.rights': 'Vos droits : accès, rectification, limitation et opposition s’exercent auprès de votre organisme de formation. Cette notice reste consultable à tout moment via le lien « Mes données ».',
  'notice.stats.noConsentNeeded': 'Ce traitement ne repose pas sur votre consentement : il n’y a rien à accepter ni à refuser, et votre accès à vos formations n’en dépend pas.',
  'notice.stats.acknowledge': 'J’ai pris connaissance',
  'notice.stats.manage': 'Mes données',

  // Roadmap produit (page admin)
  'roadmap.title': 'Nouveautés & roadmap',
  'roadmap.subtitle': 'Les évolutions du produit : ce qui est disponible dans votre version, et ce qui arrive ensuite.',
  'roadmap.status.done': 'Disponible',
  'roadmap.status.planned': 'À venir',
  'roadmap.status.exploring': 'À l\'étude',
  'roadmap.items.branding.title': 'Marque blanche',
  'roadmap.items.branding.description': 'Logo, couleurs, typographies et textes personnalisables aux couleurs de votre organisation.',
  'roadmap.items.scorm.title': 'Modules SCORM 1.2 & 2004',
  'roadmap.items.scorm.description': 'Import de packages issus de Storyline, Rise, iSpring, Captivate et autres outils auteurs.',
  'roadmap.items.sessions.title': 'Sessions & inscriptions',
  'roadmap.items.sessions.description': 'Cohortes d\'apprenants par module, avec dates d\'ouverture et de clôture optionnelles.',
  'roadmap.items.statistics.title': 'Statistiques & export CSV',
  'roadmap.items.statistics.description': 'Progression, complétion et réussite par session, exportables en CSV.',
  'roadmap.items.privacy.title': 'Information RGPD',
  'roadmap.items.privacy.description': 'Notice d\'information des apprenants, base légale documentée et journal d\'acquittement.',
  'roadmap.items.selfHosted.title': 'Installation autonome',
  'roadmap.items.selfHosted.description': 'Déploiement clé en main sur votre infrastructure, sans dépendance cloud.',
  'roadmap.items.modulePreview.title': 'Prévisualisation des modules',
  'roadmap.items.modulePreview.description': 'Testez un module dès son import, sans créer de session ni d\'inscription.',
  'roadmap.items.learnerHome.title': 'Accueil apprenant',
  'roadmap.items.learnerHome.description': 'Page d\'accueil listant les formations et la progression de chaque apprenant.',
  'roadmap.items.certificates.title': 'Attestations PDF',
  'roadmap.items.certificates.description': 'Modèle personnalisable, génération à la complétion et téléchargement par l\'apprenant.',
  'roadmap.items.learnerExperience.title': 'Espace apprenant repensé',
  'roadmap.items.learnerExperience.description': 'Interface plus claire et soignée pour vos apprenants : liste des formations, progression, téléchargement des attestations et lecteur.',
  'roadmap.items.emailReminders.title': 'Rappels email configurables',
  'roadmap.items.emailReminders.description': 'Fréquence et messages de relance personnalisables depuis l\'administration.',
  'roadmap.items.csvImport.title': 'Import d\'apprenants en masse',
  'roadmap.items.csvImport.description': 'Création de comptes apprenants par import de fichier CSV.',
  'roadmap.items.magicLink.title': 'Connexion par magic link',
  'roadmap.items.magicLink.description': 'Connexion sans mot de passe via un lien envoyé par email.',
  'roadmap.items.sso.title': 'SSO entreprise',
  'roadmap.items.sso.description': 'Activation et configuration des fournisseurs d\'identité (Entra ID, Google Workspace, Okta, OpenID Connect, SAML 2.0) depuis l\'administration.',
  'roadmap.items.webhooks.title': 'Webhooks & API',
  'roadmap.items.webhooks.description': 'Notification de votre SI (SIRH ou autre) à la complétion d\'un module.',
  'roadmap.items.xapi.title': 'Support xAPI / cmi5',
  'roadmap.items.xapi.description': 'Prise en charge des standards de tracking de nouvelle génération, au-delà de SCORM.',
  'roadmap.items.organizations.title': 'Organisations',
  'roadmap.items.organizations.description': 'Création d\'organisations pour regrouper apprenants, formations et administration.',
  'roadmap.items.orgUrl.title': 'URL par organisation',
  'roadmap.items.orgUrl.description': 'Adresse dédiée pour chaque organisation.',
  'roadmap.items.billing.title': 'Gestion de la facturation',
  'roadmap.items.billing.description': 'Formule, montant du mois, historique et coordonnées de facturation, réservés aux administrateurs.',
  'roadmap.items.payments.title': 'Paiement en ligne',
  'roadmap.items.payments.description': 'Règlement des abonnements et prestations directement depuis la plateforme.',

  // Parcours d'inscription qualifié (#155)
  'signup.title': 'Créer votre espace d\'essai',
  'signup.choice.subtitle': 'Qui êtes-vous ? Nous adaptons la suite à votre profil.',
  'signup.choice.org.title': 'Je suis un organisme de formation',
  'signup.choice.org.description': 'Créez votre espace d\'essai gratuit et invitez vos apprenants.',
  'signup.choice.learner.title': 'Je suis un apprenant ou un formateur',
  'signup.choice.learner.description': 'Vous rejoignez un organisme existant.',
  'signup.learner.description': 'Les comptes apprenant et formateur sont créés par votre organisme de formation. Rapprochez-vous de son administrateur : il vous enverra une invitation par e-mail. Il n\'y a pas d\'inscription libre pour ces profils.',
  'signup.back': 'Retour',
  'signup.form.subtitle': 'Quelques informations pour ouvrir votre espace. Aucune carte bancaire requise.',
  'signup.form.email': 'E-mail professionnel',
  'signup.form.email.hint': 'Utilisez l\'adresse de votre organisme — les adresses grand public (gmail, outlook…) ne sont pas acceptées.',
  'signup.form.orgName': 'Nom de l\'organisme',
  'signup.form.jobTitle': 'Fonction (facultatif)',
  'signup.form.phone': 'Téléphone (facultatif)',
  'signup.form.submit': 'Créer mon espace d\'essai',
  'signup.sent.title': 'Vérifiez votre boîte mail',
  'signup.sent.description': 'Si une adresse professionnelle valide a été fournie, un e-mail de confirmation vient d\'être envoyé à {{email}}. Cliquez sur le lien qu\'il contient pour confirmer votre adresse — votre demande sera ensuite examinée par notre équipe.',
  'signup.error.publicEmail': 'Merci d\'utiliser une adresse e-mail professionnelle.',
  'signup.error.generic': 'Une erreur est survenue. Réessayez dans un instant.',
  'signup.login': 'J\'ai déjà un compte',
  'signup.prompt': 'Vous êtes un organisme de formation ?',
  'signup.cta': 'Créez votre espace d\'essai',

  'confirmTrial.title': 'Confirmation de votre e-mail',
  'confirmTrial.loading': 'Nous enregistrons votre confirmation…',
  'confirmTrial.pending': 'Merci ! Votre adresse est confirmée. Votre demande est maintenant examinée par notre équipe — vous recevrez un e-mail dès qu\'elle sera validée.',
  'confirmTrial.approved': 'Votre espace a été validé ! Consultez l\'e-mail d\'activation que nous venons de vous envoyer pour définir votre mot de passe.',
  'confirmTrial.goToLogin': 'Aller à la connexion',
  'confirmTrial.rejected': 'Votre demande n\'a pas été retenue.',
  'confirmTrial.reason': 'Motif :',
  'confirmTrial.expired': 'Ce lien de confirmation a expiré. Relancez une demande d\'essai pour en recevoir un nouveau.',
  'confirmTrial.error': 'Ce lien de confirmation est invalide.',
  'confirmTrial.restart': 'Relancer une demande',

  // Revue plateforme des demandes d'essai (#155, SuperAdmin)
  'trialRequests.title': 'Demandes d\'essai',
  'trialRequests.intro': 'Les organismes qui ont confirmé leur adresse et attendent la création de leur espace.',
  'trialRequests.empty': 'Aucune demande en attente.',
  'trialRequests.col.org': 'Organisme',
  'trialRequests.col.requester': 'Demandeur',
  'trialRequests.col.jobTitle': 'Fonction',
  'trialRequests.col.confirmedAt': 'Confirmée le',
  'trialRequests.col.actions': 'Actions',
  'trialRequests.approve': 'Approuver',
  'trialRequests.reject': 'Refuser',
  'trialRequests.approved': 'Espace créé pour {{org}} — l\'activation a été envoyée.',
  'trialRequests.rejected': 'Demande de {{org}} refusée.',
  'trialRequests.error': 'Une erreur est survenue.',
  'trialRequests.rejectTitle': 'Refuser la demande de {{org}} ?',
  'trialRequests.reasonLabel': 'Motif du refus (facultatif)',
  'trialRequests.reasonPlaceholder': 'Ex. : organisme non identifiable…',
  'trialRequests.reasonHelp': 'Le motif est inclus dans l\'e-mail envoyé au demandeur.',
  'trialRequests.confirmReject': 'Refuser et prévenir',

  // Gating des capacités par formule (#155)
  'plan.locked.cta': 'Voir les formules',
  'branding.locked': 'La personnalisation de la marque (logo, couleurs, pied de page) est réservée aux formules payantes. Sur le plan gratuit, l\'espace conserve l\'identité PureLMS.',
  'sso.locked': 'L\'authentification unique (SSO) est réservée aux formules payantes.',
  'footer.free-org': 'Organisation gratuite, propulsée par PureLMS',

  // Renommage de slug d'organisation (#155)
  'organization.rename.title': 'Renommer l\'organisation ?',
  'organization.rename.warning': 'Vous changez le slug de « {{from}} » vers « {{to}} ». Ce changement est immédiat et casse tout ce qui pointe vers l\'ancienne adresse.',
  'organization.rename.break.urls': 'Les liens et favoris vers l\'ancienne adresse cessent de fonctionner.',
  'organization.rename.break.login': 'L\'écran de connexion et le branding résolus par l\'ancien slug ne répondent plus.',
  'organization.rename.break.emails': 'Les e-mails déjà envoyés (connexion, activation, rappels) pointent vers l\'ancienne adresse.',
  'organization.rename.confirm': 'Renommer malgré tout',
}
